export { default as mailIconsRegistration } from './data/mailIconsRegistration';
export { default as MailIcons } from './data/MailIcons';
//# sourceMappingURL=index.js.map